<script>
import {FinanceConsiderStore} from './FinanceConsiderStore'
import _ from 'lodash'

export default {
  data() {
    return {
      FinanceConsiderStore,

    }

  },

  watch: {

  },

  computed: {

    considerArr() {
      let out = []
      return out = _.uniqWith(FinanceConsiderStore.considerArr,function(arrVal, othVal) {
        return (arrVal.consider[0].idcategory === othVal.consider[0].idcategory)
      }).map((element) => {
        return element.consider[0]
      })

    }
  }
}
</script>

<template>
  <div class="alert alert-success mt-4" v-for="consider in considerArr">{{ consider.msg }}</div>
</template>

<style scoped>

</style>